<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "App",
  components: {}
};
</script>

<style>
html {
  overflow: auto !important;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
}
.row {
  margin-right: 0px !important;
  margin-left: 0px !important;
}
.icon-style {
  font-size: 25px;
  color: #dc3545 !important;
  padding: 6px;
}

body {
  padding-right: 0px !important;
}
</style>
